<template lang="pug">
div
  v-form(ref="form")
    v-card.rounded-lg.content-box(outlined)
      v-row
        v-col(cols="7")
          div.pa-6
            div.text-md.font-semibold.neutral700--text Write your offer message
            v-textarea.text-sm.mt-2.round-xl(ref="textarea" v-model="blast.content" placeholder="Type your message here" outlined rows="6" hide-details="auto" :rules="rules.not_empty" @input="updateCursor" @change="updateCursor" @focus="updateCursor")
            div.text-sm.font-semibold.neutral700--text.mt-5 Insert field:
            v-row(no-gutters)
              v-col.shrink.pr-3.pt-2
                v-chip(link small outlined color="neutral400" @click="insertValue('offer_name')")
                  span.neutral700--text Offer details
              v-col.shrink.pr-3.pt-2
                v-chip(link small outlined color="neutral400" @click="insertValue('recipient_name')")
                  span.neutral700--text Customer name
              v-col.shrink.pr-3.pt-2
                v-chip(link small outlined color="neutral400" @click="insertValue('company_name')")
                  span.neutral700--text Clinic’s name
              v-col.shrink.pr-3.pt-2
                v-chip(link small outlined color="neutral400" @click="insertValue('company_phone')")
                  span.neutral700--text Phone number
              v-col.shrink.pr-3.pt-2
                template(v-if="offer.redeem_method != 'show_message'")
                  v-chip(link small outlined color="neutral400" @click="insertValue('offer_code')")
                    span.neutral700--text Promo code

          v-divider.neutral300
          div.pa-6
            div.d-flex.align-center
              div
                div.text-md.font-semibold.neutral700--text Upload image (optional)
                div.text-sm.font-medium.neutral700--text Include an image in your message
              v-spacer
              div
                y-switch(v-model="blast.image_enabled")
            v-row.mt-5(v-if="resizeImageFileUrl" dense align="center")
              v-col.shrink
                v-img(:src="resizeImageFileUrl" contain max-height="150" max-width="300")
                  template(v-slot:placeholder)
                    v-row(class="fill-height ma-0" align="center" justify="center")
                      v-progress-circular(indeterminate color="grey")
              v-col
                y-button(label="Remove" size="sm" :loading="isLoading" outlined button-class="px-3" @click="removeImage")
            v-card.round-xl.pa-8.mt-4(v-else link outlined style="border-style: dashed; border-color: var(--v-neutral400)")
              .text-center
                v-avatar.mb-3(color="neutral300" size="40")
                  v-icon(color="neutral500" size="18") $yzi-image-01
                .mb-1.text-sm
                  span.info500--text.font-semibold {{ $t('click_to_upload') }} 
                  span.neutral700--text {{ $t('or_drag_and_drop') }}
                .text-xs.neutral500--text {{ $t('photo_upload_limitation') }}
              input.input-change-layout(ref="file" type="file" @change="onFileChange" accept="image/*")

          v-divider.neutral300
          div.pa-6
            div.d-flex.align-center
              div
                div.text-md.font-semibold.neutral700--text Button link (optional)
                div.text-sm.font-medium.neutral700--text Attach a hyperlink to your message
              v-spacer
              div
                y-switch(v-model="blast.hyperlink_enabled")
            v-row.mt-4
              v-col
                div.text-sm.font-semibold.neutral500--text Link
                v-text-field.text-sm.round-xl.mt-2(v-model="blast.hyperlink_url" placeholder="Enter your link" outlined dense height="48" hide-details="auto")
              v-col
                div.text-sm.font-semibold.neutral500--text Text on button
                v-text-field.text-sm.round-xl.mt-2(v-model="blast.hyperlink_text" placeholder="Enter your link" outlined dense height="48" counter="20" hide-details="auto" )
        
        v-divider.neutral300.my-3(vertical)
        v-col(cols="5")
          whatsapp-preview(title="Offer message preview" :content="blast.content")

    v-card.rounded-lg.content-box.pa-6.mt-6(outlined)
      v-row
        v-col(cols="7")
          div.text-md.font-semibold.neutral700--text Message blast frequency
          div.text-md.font-medium.neutral700--text.mt-5 Send this offer:
          v-card.round-xl.mt-2.pa-4(outlined color="neutral200" style="border-color: var(--v-neutral300) !important;")
            v-radio-group.mt-0(v-model="blast.send_cue")
              v-radio.mt-3(value="offer_activated" color="neutral700")
                template(v-slot:label)
                  div.text-md.font-medium.neutral700--text Immediately after this offer is created
              v-radio.mt-3(value="scheduled" color="neutral700" style="align-items: unset;")
                template(v-slot:label)
                  div.text-md.font-medium.neutral700--text Later on:
              template(v-if="blast.send_cue && blast.send_cue === 'scheduled'")
                div.ml-8.mt-4
                  v-row(dense)
                    v-col.grow
                      div.text-sm.font-semibold.neutral500--text Date
                    v-col.grow
                      div.text-sm.font-semibold.neutral500--text Time
                    v-col.shrink
                      div.pl-7
                  template(v-for="(schedule, index) in schedules")
                    v-row(dense :key="`sch-${index}`")
                      v-col.grow
                        date-picker-field(v-model="schedule.date" :min="getTodayDate()" required :disabled="schedules.length && schedules.length !== (index + 1)")
                      v-col.grow
                        v-text-field.text-sm.round-xl(v-model="schedule.time" outlined dense height="48" :rules="rules.not_empty" type="time" :background-color="schedules.length && schedules.length !== (index + 1) ? '' : 'neutral100'" :disabled="schedules.length && schedules.length !== (index + 1)" hide-details="auto")
                      v-col.shrink
                        v-btn.mt-2(v-if="index && schedules.length === (index + 1)" icon small @click="deleteSchedule()")
                          v-icon $yzi-trash-03
                        div.pl-7(v-else)
                  y-button.mt-3(label="Add more" prepend-icon="$yzi-plus" size="sm" @click="schedules.push({ time: '00:00' })")

</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { DateTime } from 'luxon'
import { resizeImage } from '@/utils'
import DatePickerField from '@/components/clinic/marketing/DatePickerField.vue'
import WhatsappPreview from '@/components/clinic/marketing/WhatsappPreview.vue'

export default {
  components: { DatePickerField, WhatsappPreview },
  props: {
    blastData: {
      type: Object,
      default: null
    },
    offer: {
      type: Object,
      default: (() => {})
    }
  },
  data () {
    return {
      isFetching: false,
      isLoading: false,
      resizeImageFileUrl: null,
      resizeImageFile: null,
      cursorPosition: 0,
      blast: {
        name:  'Offer message',
        send_cue: 'offer_activated',
        type: 'offer',
        method: 'whatsapp'
      },
      schedules: [{ time: '00:00' }],
      rules: {
        not_empty: [v => (v != null && v.toString().trim().length) || 'This field is required'],
        has_quantity: [v => !!v || 'This field is required', v => v != 0 || 'This field is required'],
        has_price: [(v) => !!v || 'This field is required', (v) => v >= 0 || `Amount should be more than ${this.$currency.symbol} 0`],
        not_empty_select: [v => !!v || 'This field is required']
      },
    }
  },
  computed: {
    ...mapGetters({
      company: 'getCompany'
    }),
    textarea () {
      return this.$refs.textarea.$el.querySelector('textarea')
    }
  },
  watch: {
  },
  mounted () {
    this.setData()
  },
  methods: {
    ...mapActions(['showMessage']),
    setData () {
      if (this.blastData) {
        let blast = JSON.parse(JSON.stringify(this.blastData))
        if (blast.schedules.length) {
          this.schedules = blast.schedules.map(schedue => {
            return {
              date: DateTime.fromISO(schedue.scheduled_for).toFormat('yyyy-MM-dd'),
              time: DateTime.fromISO(schedue.scheduled_for).toFormat('HH:mm')
            }
          })
        }
        if (blast.image) {
          this.resizeImageFileUrl = blast.image.file
        }
        this.blast = blast
      }
    },
    updateCursor () {
      const postion = this.textarea.selectionStart
      if (!postion) {
        setTimeout(() => {
          this.cursorPosition = this.textarea.selectionStart
        }, 500)
      } else {
        this.cursorPosition = this.textarea.selectionStart
      }
    },
    insertValue (value) {
      let text = ''
      let code = ''
      if (value === 'offer_code' && this.offer.redeem_method === 'general_code') {
        code = this.offer.coupon_code
      } else {
        code = `{{ ${value} }}`
      }
      if (this.blast.content) {
        text = `${this.blast.content.substring(0, this.cursorPosition)}${code}${this.blast.content.substring(this.cursorPosition, this.blast.content.length)}`
      } else {
        text = code
      }
      this.$set(this.blast, 'content', text)
    },
    deleteSchedule () {
      this.schedules.pop()
    },
    saveData () {
      if (!this.$refs.form.validate()) {
        this.showMessage(['error', this.$t('error_message.please_fill_out_all_required')])
        return
      }
      this.isLoading = true
      let payload = {
        name: this.blast.name,
        method: this.blast.method,
        type: this.blast.type,
        content: this.blast.content,
        send_cue: this.blast.send_cue,
        image_enabled: this.blast.image_enabled,
        hyperlink_enabled: this.blast.hyperlink_enabled,
        hyperlink_url: this.blast.hyperlink_url,
        hyperlink_text: this.blast.hyperlink_text,
        schedules: []
      }
      if (payload.send_cue === 'scheduled') {
        payload.schedules = this.schedules.map(m => {
          return `${m.date} ${m.time}`
        })
      }
      if (this.blast.id) {
        this.$axios.patch(`/marketing/${this.company.slug}/offers/${this.offer.id}/blasts/${this.blast.id}`, payload)
          .then((resp) => {
            if (this.resizeImageFile) {
              this.updateImage(resp.data.id)
            } else {
              this.$emit('updated')
              this.closeDialog()
            }
          })
          .catch(err => {
            let message = this.$t('error_message.unable_to_complete_request')
            if (err.response.data) {
              if (err.response.data.detail) {
                message = err.response.data.detail
              } else {
                let data = JSON.stringify(err.response.data).replace(/[^\w.\s:]/g, '').replace(/[.:]/g, match => match + ' ')
                if (data) { message = data }
              }
            }
            this.showMessage(['error', message])
          })
          .finally(() => {
            if (!this.resizeImageFile) {
              this.isLoading = false
            }
          })
      } else {
        this.$axios.post(`/marketing/${this.company.slug}/offers/${this.offer.id}/blasts`, payload)
          .then(resp => {
            if (this.resizeImageFile) {
              this.updateImage(resp.data.id)
            } else {
              this.$emit('updated')
              this.closeDialog()
            }
          })
          .catch(err => {
            let message = this.$t('error_message.unable_to_complete_request')
            if (err.response.data) {
              if (err.response.data.detail) {
                message = err.response.data.detail
              } else {
                let data = JSON.stringify(err.response.data).replace(/[^\w.\s:]/g, '').replace(/[.:]/g, match => match + ' ')
                if (data) { message = data }
              }
            }
            this.showMessage(['error', message])
          })
          .finally(() => {
            if (!this.resizeImageFile) {
              this.isLoading = false
            }
          })
      }
    },
    updateImage (id) {
      var formdata = new FormData()
      formdata.append('image', this.resizeImageFile)
      this.$axios.patch(`/marketing/${this.company.slug}/offers/${this.offer.id}/blasts/${id}`, formdata)
        .then(() => {
          this.$emit('updated')
          this.closeDialog()
        })
        .catch(err => {
          let message = this.$t('error_message.unable_to_upload_image')
          if (err.response.data) {
            if (err.response.data.detail) {
              message = err.response.data.detail
            } else {
              let data = JSON.stringify(err.response.data).replace(/[^\w.\s:]/g, '').replace(/[.:]/g, match => match + ' ')
              if (data) { message = data }
            }
          }
          this.showMessage(['error', message])
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    async onFileChange(e) {
      const files = e.target.files || e.dataTransfer.files
      if (!files.length) {
        return
      }
      const resizedImage = await resizeImage(files[0], 'company_image.jpeg')
      this.resizeImageFileUrl = resizedImage.dataURL
      this.resizeImageFile = resizedImage.file
    },
    removeImage () {
      if (!(this.blast.image && this.blast.image.id)) {
        this.resizeImageFileUrl = null
        this.resizeImageFile = null
        return
      }
      this.isLoading = true
      this.$axios.delete(`/images/${this.blast.image.id}`)
        .then(() => {
          this.resizeImageFileUrl = null
          this.resizeImageFile = null
        })
        .catch(err => {
          let message = this.$t('error_message.unable_to_upload_image')
          if (err.response.data) {
            if (err.response.data.detail) {
              message = err.response.data.detail
            } else {
              let data = JSON.stringify(err.response.data).replace(/[^\w.\s:]/g, '').replace(/[.:]/g, match => match + ' ')
              if (data) { message = data }
            }
          }
          this.showMessage(['error', message])
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    getTodayDate () {
      return DateTime.local().toFormat('yyyy-MM-dd')
    }
  },
}
</script>

<style lang="scss" scoped>
.input-change-layout {
  position: absolute;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  opacity: 0;
}
::v-deep {
  .v-text-field--outlined {
    fieldset {
      border-color: var(--v-neutral400);
    }
  } 
  .error--text {
    color: var(--v-danger500) !important;
    fieldset {
      border-color: var(--v-danger500);
    }
  }
}
</style>